/**
 * Use select to jump to anchors
 *
 * @since   1.0.0
 * @package hbs
 */

(function($) {
    $(document).ready(function( event ) {
        $('#subnavMobile').on('change', function() {
            var target = $( $(this).val() );
            console.log('target', target);
            
            var offset = 0;

            // Add height of banner to offset
            offset += $('header[role=banner]').outerHeight();

            console.log('jumping to ', target.offset().top - offset)
            $('html, body').animate({
            
                scrollTop: target.offset().top - offset

            }, 0);
        })
    }); // document.ready
})(jQuery);
